import * as React from "react"
const UnorderedListIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#A1A1A1"
      d="M1.623 3.319a1.624 1.624 0 1 0 0-3.247 1.624 1.624 0 0 0 0 3.247ZM1.623 8.142a1.624 1.624 0 1 0 0-3.247 1.624 1.624 0 0 0 0 3.247ZM1.623 12.965a1.624 1.624 0 1 0 0-3.247 1.624 1.624 0 0 0 0 3.247ZM5 1.195h11v1H5v-1ZM5 6h11v1H5V6ZM5 10.805h11v1H5v-1Z"
    />
  </svg>
)
export default UnorderedListIcon
